module.exports = __webpack_public_path__ + "media/images/pc/specials/fair/main-visual-c9a062af8e4085193c05b07d0c5490ad.jpg";